var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "h-full",
    viewBox: "0 0 1981 1203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M913.521 1170.67L31.9708 289.112C-10.5456 246.596 -10.5456 177.666 31.9708 135.154L134.79 32.3353C177.233 -10.1086 246.023 -10.1903 288.566 32.1538L990.502 730.801L1692.43 32.1538C1734.98 -10.1903 1803.77 -10.1086 1846.21 32.3353L1949.03 135.154C1991.55 177.67 1991.55 246.6 1949.03 289.112L1067.48 1170.67C1024.97 1213.18 956.038 1213.18 913.521 1170.67Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.af8c066994fb0cd9f3494e3724a3c484.svg";
export { ForwardRef as ReactComponent };